var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'Accordion__item__label--has-selected': _vm.count}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.count)?[_vm._v("("+_vm._s(_vm.count)+")")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }